<template>
    <div class="login">
        <navigation-bar Close/>
        <div class="main-content">
            <div class="logo">
                <Logo/>
            </div>
            <div class="tabs-login">
                <el-form class="textBox" :model="loginform" ref="loginForm">
                    <el-form-item>
                        <OpenEyes ref="selectCountryCode" v-model="countryCodeData" :countryCodeData="loginform.countryCodeData" :value="loginform.tel" :placeholder="'輸入手機'" :name="'loginTel'" :type="'tel'" :maxlength='19' class="input-round" @onChange="valueChange" isCountryCode :disabled="toLogin"/>

                    </el-form-item>
                    <el-form-item v-if="toLogin">
                        <el-input
                            placeholder="輸入密碼"
                            v-model="loginform.password"
                            show-password
                            autocomplete="off"
                            maxlength="12"/>
                    </el-form-item>
                </el-form>
                <div class="btn_box" v-if="!toLogin">
                    <el-button @click="registered" round type="warning">登入 / 註冊</el-button>
                </div>
                <template v-else>
                    <div class="forget" @click="goPhoneVerify">
                        忘記密碼？
                    </div>
                    <div class="btn_box">
                        <el-button @click="toLogin = false" round type="info">上一步</el-button>
                        <el-button @click="login" round type="warning">登入</el-button>
                    </div>
                </template>
            </div>
        </div>
        <!--網頁用-->
        <CommDialog :value="isShowDialogWeb"
                    class="isWeb isSmall"
                    :appendToBody="true"
                    :isIcon="false"
                    :isCancel="false"
                    :outerContent="''"
                    :isShowClose="true"
                    @result="onCommDialogClose">
            <!--忘記密碼-->
            <PhoneVerify isWeb @push="pushDataToken" :dataTokenWeb="dataTokenWeb" class="web-content" v-if="isShowDialogWeb && isTypeWeb==='PhoneVerify'"/>
            <!--忘記密碼的更改密碼-->
            <ResetPwd isWeb :dataTokenWeb="dataTokenWeb" @result="onCommDialogClose" class="web-content" v-if="isShowDialogWeb && isTypeWeb==='ResetPwd'"/>
            <!--註冊用 手機驗證-->
            <RegisterPhoneVerify isWeb @push="pushDataToken" @result="onCommDialogClose" :dataTokenWeb="dataTokenWeb" class="web-content" v-if="isShowDialogWeb && isTypeWeb==='RegisterPhoneVerify'"/>
            <!--註冊頁-->
            <Register isWeb :dataTokenWeb="dataTokenWeb" @result="onCommDialogClose" class="web-content" v-if="isShowDialogWeb && isTypeWeb==='Registered'"/>
        </CommDialog>

        <div class="brand" v-if="!isWeb">
            <span>LIFE LINK 串門子品牌服務系統</span>
        </div>

        <!--LINE登入綁定使用-->
        <div class="vld-overlay is-active is-line is-full-page"
             v-if="dataObject.isLine && isBindingLine">
            <div class="vld-background"/>
            <div class="vld-icon"><div class="loader"/></div>
        </div>

        <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true"
                v-else>
        </loading>

        <toast/>
    </div>
</template>

<script>
import {checkPhone, checkPassword, checkPhoneByCountryCode} from "@/util/validators";
import countryCode from "@/json/country_code.json";
    import Toast from "@/components/Toast.vue";
    import * as mutationTypes from '@/store/mutationTypes';
    import * as constDefine from '@/store/constDefine';
    import Logo from "@/components/Logo";
    import OpenEyes from "@/components/OpenEyes"
    import {saveCryptoUserInfo, saveCryptoUserPhone} from "@/util/cryptoLocalStorage";
    import CommDialog from '@/components/CommDialog.vue';
    import PhoneVerify from '@/views/auth/PhoneVerify';
    import ResetPwd from '@/views/auth/ResetPwd';
    import RegisterPhoneVerify from '@/views/auth/RegisterPhoneVerify';
    import Register from '@/views/auth/Register';
    export default {
        name: "Login",
        props: {
            isWeb: Boolean,
            isEvent: Boolean,
            defaultLoginForm: {type: Object, default: () => ({})},
        },
        components: {Toast, Logo , OpenEyes ,CommDialog , PhoneVerify , ResetPwd , RegisterPhoneVerify , Register},
        data() {
            return {
                isLoading: false,
                fcmToken:'',
                loginform: {
                    tel: "",
                    password: "",
                    countryName: "",
                    countryCode: "",
                    countryCodeData: {cnName: "台灣", code: "+886", enName: "TW", key: 1}, //國碼物件與Calculator模組回傳一致
                },
                dataToken: "",
                dataObject: {},
                isDeleteAccount: false,
                countryCodeData: {cnName: "台灣", code: "+886", enName: "TW", key: 1}, //國碼物件與Calculator模組回傳一致
                selectCountryCode: [],
                toLogin: false,//已經有註冊過要登入
                registeredForm: {
                    tel: "",
                    countryCodeData: {cnName: "台灣", code: "+886", enName: "TW", key: 1}, //國碼物件與Calculator模組回傳一致
                },

                dataTokenWeb: '',
                isTypeWeb: '',
                isShowDialogWeb: false,

                //已綁定Line
                isBindingLine: false,
                lintBotBasicId: "",
                lineUserId: "",
                uid: 0,
            };
        },
        created() {
            this.loginform.tel = "";
            this.loginform.password = "";
            this.loginform.countryCode = "";
            this.loginform.countryName = "";

            if (this.defaultLoginForm?.countryCodeData) {
                this.loginform.countryCodeData = this.defaultLoginForm.countryCodeData
            }

            if (this.defaultLoginForm?.tel) {
                this.loginform.countryCodeData.tel = this.defaultLoginForm.tel
            }
        },
        mounted() {
            if (this.$route.params.dataToken !== undefined) {
                this.dataToken = this.$route.params.dataToken;
            } else if (this.$route.query.dataToken !== undefined) {
                this.dataToken = this.$route.query.dataToken;
            }

            try {
                let dataObject = this.$crypto.uriComponentToObject(this.dataToken)
                if (dataObject.usedType === "DeleteAccount") {
                    this.isDeleteAccount = true
                }

                this.dataObject = dataObject
            } catch (e) {
                this.isDeleteAccount = false
                this.dataObject = {}
            }

            try {
                let loginObject = this.$crypto.uriComponentToObject(sessionStorage.getItem('loginToken'))
                // sessionStorage.removeItem('loginToken')

                let isOk = false
                if ((this.dataObject.usedType === "webGetCoupon" && this.dataObject.id > 0) ||
                    (this.dataObject.uri === "web-store-info" &&
                        (this.dataObject.usedType === "webIndex" || this.dataObject.usedType === "reward-point" ||
                            this.dataObject.usedType === "member" ||this.dataObject.usedType === "loyalty-card" ||
                            this.dataObject.usedType === "coupon" || this.dataObject.usedType === "oin-card") &&
                        (this.dataObject.storeCode !== undefined && this.dataObject.storeCode !== ""))
                ) {
                    isOk = true
                }

                if (loginObject.uId !== 0 && loginObject.tel === "" && loginObject.password === "" && loginObject.message !== "") {
                    this.$store.commit(mutationTypes.SHOW_TOAST, loginObject.message);
                }

                if (isOk && loginObject.usedType === this.$route.name && loginObject.tel !== "" && loginObject.password !== "" && loginObject.countryCode !== "" && loginObject.countryName !== "") {
                    // countryCode + countryName取得CountryData
                    this.loginform.countryCodeData = this.$public.getCountryData(loginObject.countryCode, loginObject.countryName)
                    this.loginform.tel = loginObject.tel
                    this.loginform.password = loginObject.password
                    let countryCodeData = countryCode.filter(d => d.countryEnName === loginObject.countryName && d.countryCode === loginObject.countryCode).map((d, index) => { return { 'enName': d.countryEnName, 'cnName': d.countryCnName, 'code': d.countryCode, 'key': index} })
                    this.loginform.countryCodeData.enName = countryCodeData[0].enName
                    this.loginform.countryCodeData.code = countryCodeData[0].code
                    this.loginform.countryCodeData.cnName = countryCodeData[0].cnName
                    this.loginform.countryCodeData.key = countryCodeData[0].key
                    this.isBindingLine = true
                    this.login()
                }
            } catch (e) {
                //
            }

        },
        methods: {
            login: function () {
                let self = this;
                if (!checkPhoneByCountryCode(this.loginform.tel, this.loginform.countryCodeData.code)) {
                    this.$store.commit(mutationTypes.SHOW_TOAST, '手機號碼格式有問題');
                    return;
                }
                if (!checkPassword(this.loginform.password)) {
                    this.$store.commit(mutationTypes.SHOW_TOAST, '密碼必須為6-12英文數字混合');
                    return;
                }

                this.isLoading = true;
                this.$http.fetchWithEncrypt`SignIn${{
                    'countryCode': this.loginform.countryCodeData.code,
                    'countryName': this.loginform.countryCodeData.enName,
                    'phone': this.loginform.tel,
                    'password': this.loginform.password,
                    'userType': this.dataObject.userType || '',
                    "isLine": this.dataObject.isLine || false,
                    "lineUserId": this.dataObject.lineUserId || '',
                    "lineBasicId": this.dataObject.botId || '',
                }}
                ${json => {

                    self.isLoading = false;

                    if (json.status === true) {
                        self.$auth.setAdminToken(json.data.token);
                        // localStorage.setItem('phone', self.loginform.tel);
                        saveCryptoUserPhone(self.loginform.tel);
                        localStorage.setItem('token', json.data.token);
                        localStorage.setItem('nickName', json.data.nickName);
                        localStorage.setItem('userCode', json.data.userCode);
                        localStorage.setItem('lineToken', this.dataToken);
                        sessionStorage.removeItem('loginToken')

                        self.isLoading = true;
                        self.getUserInfo();
                        //取得 fcm token
                        self.receiveNotification();

                    } else if (json.data !== null && json.data.lineStatus !== undefined && json.data.lineStatus === -1 && json.data.phoneStatus === -1 && this.dataObject.isLine) {
                        //同一個LINE頻道已綁定，同一個USER ID 卻不同LINE ID時，就要走重新註冊流程
                        let CN = self.loginform.countryCodeData.code
                        self.$router.push({name: 'RegisterPhoneVerify', query: {tel: self.loginform.tel ,type: CN==="+886" ? 'Code' : 'noCode', countryCode: self.loginform.countryCodeData.code, countryName: self.loginform.countryCodeData.enName, dataToken: self.dataToken}, params:{reg:'register', lineStatus: "verifyPhone", isLine: true}})
                    } else {
                        self.$store.commit(mutationTypes.SHOW_TOAST, json.message);
                    }
                }}`;
            },
            getUserInfo: function () {
                let self = this;
                this.$http.fetchWithAuth`GetUserInfoWithId${{}}
                ${json => {
                    self.isLoading = false;
                    saveCryptoUserInfo(json.data);

                    if(self.isDeleteAccount) {
                        let dataToken = this.$crypto.objectToURIComponent({
                            usedType: "DeleteAccount",
                            password: this.loginform.password,
                        })

                        self.$public.setPathAfterLogin("DeleteAccount", {dataToken: dataToken})
                    }

                    //檢查是否有儲存登入後要跳轉的頁面及參數，在 login頁面登入成功後跳轉
                    let nextPath = self.$public.getPathAfterLogin();
                    let nextPathParam = self.$public.getParamAfterLogin();

                    if (self.$public.notNull(nextPath) && nextPath !== "") {
                        if ( self.$public.notNull(nextPathParam) && nextPathParam !== "") {
                            self.$router.replace({name: nextPath, params:nextPathParam});
                        } else {
                            self.$router.replace({name: nextPath});
                        }
                        self.$public.clearCartPathSession();
                    } else if (self.dataObject.usedType === "webGetCoupon" && self.dataObject.id > 0) {
                        self.$router.replace({name: 'CouponPage', query: {'dataToken': self.dataToken}});
                    } else if ((this.dataObject.uri === "web-store-info" &&
                        (this.dataObject.usedType === "webIndex" || this.dataObject.usedType === "reward-point" ||
                            this.dataObject.usedType === "member" ||this.dataObject.usedType === "loyalty-card" ||
                            this.dataObject.usedType === "coupon" || this.dataObject.usedType === "oin-card") &&
                        (this.dataObject.storeCode !== undefined && this.dataObject.storeCode !== ""))
                    ) {
                        let usedType = this.dataObject.usedType === "webIndex" ? "" : "/" + this.dataObject.usedType
                        let path = this.dataObject.uri + "/" + this.dataObject.storeCode + usedType;
                        self.$router.replace({path: path});
                    } else {
                        self.goBack();
                    }

                    if (self.isWeb) {
                        if (self.isEvent) {
                            this.$emit('triggerEvent', {
                                event: 'result',
                                data: json.data,
                            })
                        } else {
                            //重新整理
                            window.location.reload();
                        }
                    }

                }}`;
            },

            /** 是否已經註冊過? */
            async registered() {
                if (!checkPhoneByCountryCode(this.loginform.tel, this.loginform.countryCodeData.code)) {
                    this.$store.commit(mutationTypes.SHOW_TOAST, '手機號碼格式有問題');
                    return;
                }

                // web版功能  在Line App聊天視窗開啟 與 Android裝置 同時滿足才work.
                if (this.$http.getLineAppOpen() && this.$http.getOS() === 'Android'){
                    //寫入參數值給LineLiff.vue(liff url)判斷終止掃碼 只取得授權
                    localStorage.setItem("from", "Login");
                    //window open開啟liff url
                    await window.open("https://liff.line.me/2008934720-dx73LUSg");
                }

                this.$http.fetch`IsRegister${{
                    'countryCode': this.loginform.countryCodeData.code,
                    'countryName': this.loginform.countryCodeData.enName,
                    'phone': this.loginform.tel,
                    "isLine": this.dataObject.isLine || false,
                    "lineUserId": this.dataObject.lineUserId || '',
                    "lineBasicId": this.dataObject.botId || '',
                }}
                ${json => {
                    let self = this;
                    //1: 尚未註冊，2:已註冊， 3:在別的地方註冊過
                    if (json.data.isRegister === 1) {
                        if(self.loginform.countryCodeData.code==='+886'){
                            if ((self.dataObject.usedType === "webGetCoupon" && self.dataObject.id > 0) || (self.dataObject.usedType === "webIndex" ||
                                self.dataObject.usedType === "reward-point" || self.dataObject.usedType === "member" ||
                                self.dataObject.usedType === "loyalty-card" || self.dataObject.usedType === "coupon" ||
                                self.dataObject.usedType === "oin-card") && self.isLine === true) {
                                self.$router.push({name: 'RegisterPhoneVerify', query: {tel: this.loginform.tel ,type: 'Code', countryCode: this.loginform.countryCodeData.code, countryName: this.loginform.countryCodeData.enName, dataToken: self.dataToken}, params:{reg:'register'}})
                            } else {
                                if(!self.isWeb){
                                    //APP、LINE綁定、商圈網頁版用
                                    self.$router.push({name: 'RegisterPhoneVerify', query: {tel: this.loginform.tel ,type: 'Code', countryCode: this.loginform.countryCodeData.code, countryName: this.loginform.countryCodeData.enName, isLine: this.dataObject.isLine || false, dataToken: self.dataToken}, params:{reg:'register'}})
                                }else {
                                    //單店純網頁版用
                                    self.dataTokenWeb = {tel: this.loginform.tel,type: 'Code', countryCode: this.loginform.countryCodeData.code, countryName: this.loginform.countryCodeData.enName, reg:'register', lineStatus: "lineVerifyPhone", isLine: this.dataObject.isLine || false, dataToken: self.dataToken}
                                    self.isTypeWeb = 'RegisterPhoneVerify'
                                    self.isShowDialogWeb = true
                                }
                            }
                        }else {
                            if(!self.isWeb){
                                //APP、LINE綁定、商圈網頁版用
                                self.$router.push({name: 'RegisterPhoneVerify', query: {tel: this.loginform.tel ,type: 'noCodeForeign', countryCode: this.loginform.countryCodeData.code, countryName: this.loginform.countryCodeData.enName, isLine: this.dataObject.isLine || false, dataToken: self.dataToken }, params:{reg:'register'}})
                            }else {
                                //單店純網頁版用
                                self.dataTokenWeb = {tel: this.loginform.tel ,type: 'noCodeForeign', countryCode: this.loginform.countryCodeData.code, countryName: this.loginform.countryCodeData.enName, isLine: this.dataObject.isLine || false, dataToken: self.dataToken, reg:'register'}
                                self.isTypeWeb = 'RegisterPhoneVerify'
                                self.isShowDialogWeb = true
                            }
                        }
                    } else if (json.data.isRegister === 2) {
                        if (this.dataObject.isLine && !json.status) {
                            self.$store.commit(mutationTypes.SHOW_TOAST, json.message);
                        }

                        if (this.dataObject.isLine && json.data.lineStatus ===1 && json.data.phoneStatus === 0 && json.data.status === "loginVerify") {
                            //LineUser未綁定UserId
                            let CN = self.loginform.countryCodeData.code
                            self.$router.push({name: 'RegisterPhoneVerify', query: {tel: this.loginform.tel ,type: 'noCodeForeign', countryCode: this.loginform.countryCodeData.code, countryName: this.loginform.countryCodeData.enName, isLine: this.dataObject.isLine || false, dataToken: self.dataToken }, params:{reg:'forgetPassword', lineStatus: json.data.status, isLine: true}})
                            // self.$router.push({name: 'RegisterPhoneVerify', query: {tel: self.loginform.tel ,type: CN==="+886" ? 'Code' : 'noCode', countryCode: self.loginform.countryCodeData.code, countryName: self.loginform.countryCodeData.enName, dataToken: self.dataToken}, params:{reg:'register', lineStatus: json.data.status, isLine: true}})
                        }
                        if (this.dataObject.isLine && json.data.lineStatus ===-1 && json.data.phoneStatus === -1) {
                            //同一個LINE頻道已綁定，同一個USER ID 卻不同LINE ID時，就要走重新註冊流程
                            let CN = self.loginform.countryCodeData.code
                            self.$router.push({name: 'RegisterPhoneVerify', query: {tel: self.loginform.tel ,type: CN==="+886" ? 'Code' : 'noCode', countryCode: self.loginform.countryCodeData.code, countryName: self.loginform.countryCodeData.enName, dataToken: self.dataToken}, params:{reg:'forgetPassword', lineStatus: "lineVerifyPhone", isLine: true}})
                        }
                        if (this.dataObject.isLine !== true) {
                            self.toLogin= true
                        }
                    } else if (json.data.isRegister === 3) {
                        self.$router.push({name: 'SecReg', query: {tel: this.loginform.tel , firstStoreIcon:json.data.firstStoreIcon, registeredStoreIconList:json.data.registeredStoreIconList}})
                    } else {
                        self.$store.commit(mutationTypes.SHOW_TOAST, json.message);
                    }
                }}`;
            },
            /** 推播處理 */
            receiveNotification: function () {
                let self = this;
                if (window.FirebasePlugin) {
                    let FirebasePlugin = window.FirebasePlugin;
                    //取得本機的 fcm token並更新
                    FirebasePlugin.getToken(function (token) {
                        window.localStorage.setItem(constDefine.KEY_FCM_TOKEN, token);
                        self.fcmToken = token;
                        //如果已登入才更新 device token
                        if(self.$auth.isAdminLogin()) {
                            self.updateFcmToken();
                        }
                    });
                }
            },
            /** 上傳新的 fcm token */
            updateFcmToken: function () {
                let self = this;

                this.$http.fetchWithAuth`UpdateDeviceToken${{
                    'token': self.fcmToken,
                    'os': self.$http.getOS(),
                }}`;
            },

            goBack: function () {
                if (!this.isWeb){
                    //APP、LINE綁定、商圈網頁版用
                    this.$router.go(-1)
                }else {
                    //單店純網頁版用
                    this.$emit('close',true);
                }

            },
            valueChange(countryData,phone){
                this.loginform.tel = phone;
                this.loginform.countryCodeData = countryData;
            },
            goPhoneVerify(){
                if(!this.isWeb){
                    //APP、LINE綁定、商圈網頁版用
                    this.$router.push({ name: 'PhoneVerify' , query: {nextTo: 'ForgotPassword', tel: this.loginform.tel ,type: 'Code', countryCode: this.loginform.countryCodeData.code, countryName: this.loginform.countryCodeData.enName, dataToken: this.dataToken, reg:'register', isLine: this.dataObject.isLine}})
                }else {
                    //單店純網頁版用
                    this.dataTokenWeb = {nextTo: 'ForgotPassword', tel: this.loginform.tel ,type: 'Code', countryCode: this.loginform.countryCodeData.code, countryName: this.loginform.countryCodeData.enName, dataToken: this.dataToken, reg:'register', isLine: this.dataObject.isLine}
                    this.isTypeWeb = 'PhoneVerify'
                    this.isShowDialogWeb = true
                }
            },
            onCommDialogClose(result) {
                this.isShowDialogWeb = false;
                if(result){
                    //更改密碼、註冊成功
                    this.$emit('close', true);
                }
            },
            pushDataToken( dataToken , type){
                this.dataTokenWeb = dataToken
                this.isTypeWeb = type
            },
        }
    };
</script>

<style lang="less" scoped src="../../less/login.less"/>
